{
    "Accessibility menu": "Tilgængelighedsmenu",
    "Close": "Luk",
    "Text and Reading": "Tekst og læsning",
    "Navigation and Interaction": "Navigation og interaktion",
    "Text Align": "Tekstjustering",
    "Align Left": "Venstrejuster",
    "Align Center": "Centrer",
    "Align Right": "Højrejuster",
    "Adjust Font Size": "Juster skriftstørrelse",
    "Highlight Title": "Fremhæv titel",
    "Highlight Links": "Fremhæv links",
    "Readable Font": "Læsbar skrifttype",
    "Color and Contrast": "Farve og kontrast",
    "Dark Contrast": "Mørk kontrast",
    "Light Contrast": "Lys kontrast",
    "High Contrast": "Høj kontrast",
    "High Saturation": "Høj mætning",
    "Low Saturation": "Lav mætning",
    "Monochrome": "Monokrom",
    "Tools": "Værktøjer",
    "Reading Guide": "Læseguide",
    "Big Cursor": "Stor markør",
    "Increase Font Size": "Forøg skriftstørrelse",
    "Decrease Font Size": "Formindsk skriftstørrelse",
    "Letter Spacing": "Bogstavafstand",
    "Line Height": "Linjehøjde",
    "Font Weight": "Skrifttykkelse",
    "Dyslexia Font": "Skrifttype til ordblindhed",
    "Language": "Sprog",
    "Accessibility widget": "Åbn tilgængelighedsmenu",
    "Accessibility Profiles": "Tilgængelighedsprofiler",
    "Cognitive Disability": "Kognitivt handicap",
    "Seizure Safe": "Anfaldsikker",
    "Accessibility statement": "Tilgængelighedserklæring",
    "ADHD": "ADHD",
    "Low Vision": "Nedsat syn",
    "Pause Animations": "Sæt animationer på pause",
    "Animation paused": "Animation sat på pause",
    "Reset all settings": "Nulstil indstillinger",
    "Shortcut:": "Genvej:",
    "Epilepsy Safe Mode": "Epilepsisikker tilstand",
    "Mute sounds": "Slå lyd fra",
    "Page read": "Læs siden op",
    "Page read controls": "Oplæsningsstyring",
    "Pause": "Pause",
    "Resume": "Fortsæt",
    "Stop": "Stop",
    "Settings": "Indstillinger",
    "Speed": "Hastighed",
    "Voice": "Stemme",
    "Close accessibility menu": "Luk tilgængelighedsmenu",
    "Back to accessibility menu": "Tilbage til tilgængelighedsmenu",
    "Search languages": "Søg efter sprog",
    "Selected language": "Valgt sprog",
    "View accessibility statement (opens in new window)": "Se tilgængelighedserklæring (åbner i nyt vindue)",
    "Visit CookieYes website (opens in new window)": "Besøg CookieYes-webstedet (åbner i nyt vindue)",
    "Reset all accessibility settings to default": "Nulstil alle tilgængelighedsindstillinger"
}
